export default __webpack_public_path__ + "static/media/VD1.40565d7f.png";